import React from 'react';
import * as Icons from '../icons/icons';
import { getTrigger } from '../workfloweditor/available_steps';
import { AppItemPermissionLevel, AvailableActions, PublishedApp, Recipe } from '../workfloweditor/workflow-types';
import { getPermissionLevelPriority } from '../workfloweditor/helpers';

export function getRecipeCmsQuery() {
  // format of a json graphql payload
  return {
    query: `query RecipeQuery { Workflow_Recipes(filter: {status: {_eq: "published"}}, sort: "sort") { id name description trigger steps environment trial } }`
  };
}

export function getUseCaseCmsQuery() {
  // format of a json graphql payload
  return {
    query: `query UseCaseQuery { Workflow_Usecases { id App Usecases } }`
  };
}

export function getIcon(iconName: string, key?: string | number) {
  if (iconName == null) {
    return null;
  }

  if (iconName.indexOf('http') === 0) {
    return Icons.ImageWrapper(iconName, key);
  }

  const Icon = Icons[iconName != null ? iconName : 'Webhook'];
  return <Icon key={key} />;
}

export function getRecipePermissionLevel(recipe: Recipe, availableActions: AvailableActions): AppItemPermissionLevel {
  let permissionLevel: AppItemPermissionLevel = null;
  const trigger = getTrigger(availableActions, recipe.trigger);
  if (trigger) {
    permissionLevel = trigger.permissionLevel;
  }

  for (const step of recipe.steps) {
    if (step.appId) {
      const action = availableActions.actions.find((x) => x.appId === step.appId && x.appCommand === step.appCommand);
      if (
        action?.permissionLevel &&
        action.permissionLevel !== AppItemPermissionLevel.Unlisted &&
        action.permissionLevel !== AppItemPermissionLevel.Deprecated
      ) {
        if (!permissionLevel || getPermissionLevelPriority(permissionLevel) < getPermissionLevelPriority(action.permissionLevel)) {
          permissionLevel = action.permissionLevel;
        }
      }
    }
  }

  return permissionLevel;
}

export function findFirstStepIcon(recipe: Recipe, publishedApps: PublishedApp[], availableActions: AvailableActions): string {
  for (const step of recipe.steps) {
    if (step.appId === '4723e786-7c8d-4229-ad0a-2638259664c8') {
      const gfServicesApp = publishedApps.find((app) => app.appId === '4723e786-7c8d-4229-ad0a-2638259664c8');
      const command = gfServicesApp.package.commands.find((command) => command.key === step.appCommand);
      if (command?.icon) {
        return command.icon;
      }
    } else {
      return availableActions.actions.find((action) => action.appId === step.appId && action.appCommand === step.appCommand)?.icon;
    }
  }
}
